<ion-app [ngClass]="{'light': !isDarkmode, 'dark': isDarkmode}">
  <app-splash *ngIf="authSrv.isSecondSplash" [finish]="authSrv.secondSplashAnimation" style="z-index: 11;"></app-splash>
  <app-quick-search *ngIf="quickSearchSrv.isQuickSearchOpen"></app-quick-search>  
  <div *ngIf="!isLogin && !menu.showNothing">
    <app-navigation *ngIf="!menu.isCustomer && menu.showNavigation"></app-navigation>
    <cu-navigation *ngIf="menu.isCustomer"></cu-navigation>
  </div>
  
  <ion-router-outlet></ion-router-outlet>
</ion-app>